import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextFieldFullWidth from './TextFieldFullWidth';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useFormFields } from '../libs/hooksLib';
import { isEmpty } from '../libs/isEmpty';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

export default function FeaturetypeModal({
  ...props
}) {

  const initalValues= () => {
    if (isEmpty(props.values)) {
      let obj = {
         active: false,
         alias: "",
         config: "",
         transform: "",
         ds_id: "",
         is_interesse: false,
         is_manuel: false
      }
      return obj
    } else {
      //console.log(props.values)
      return props.values
    }
  }

  const [isLoading, setIsLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [fields, setValues, handleFieldChange] = useFormFields(initalValues);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [errorMessage, setErrorMessage] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setValues(initalValues)
    setOpen(false);
  };

  async function handleSubmit(event) {
    event.preventDefault();
    let body = fields
    //console.log(body)
    props.acceptAction({body})
    handleClose()
  }

  // Handle validation
  function validateForm() {
    let errors = []

    // Check for JSON in conf
    try {
      JSON.parse(fields.config);
    } catch (e) {
    errors.push("Config: ikke valid")
    }
    try {
      JSON.parse(fields.transform);
    } catch (e) {
      errors.push("Transform: ikke valid")
    }

    if (fields.alias.length === 0) {
      errors.push("Alias: må ikke være tom.")
    }

    if (fields.ds_id.length === 0) {
      errors.push("Datasource: må ikke være tom.")
    }


    if (errors.length > 0) {
      return false
    } else {
      return true
    }
    
  }

  const datasources = props.sources

  return (
    <div>
      <Button
        disabled={props.disabled}
        variant={props.btnVariant}
        color={props.btnColor}
        onClick={handleClickOpen}>
        {props.btnText}
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="datasource-modal"
        fullWidth={true}
        maxWidth={"sm"}

      >
        <form noValidate autoComplete="off" onSubmit={handleSubmit} key={isLoading}>
        <DialogTitle id="datasource-modal">{props.titleText}</DialogTitle>
        <DialogContent>
        <Typography variant='body2'>{props.info}</Typography> 
        <hr></hr>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
            <Grid item>
              <TextFieldFullWidth 
                id="alias"
                label="Alias"
                placeholder=""
                helperText="Navngivning"
                value={fields.alias}
                onChange={handleFieldChange}
                isLoading={isLoading}                  
              />
            </Grid>
            <Grid item>
            <FormControl>
              <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                Datasource
              </InputLabel>
              <Select
                labelId="demo-simple-select-placeholder-label-label"
                value={fields.ds_id}
                onChange={handleFieldChange}
                displayEmpty
                name="ds_id"
                >
                <MenuItem value=""></MenuItem>
                {datasources.map(row => (
                  <MenuItem key={row.ds_id} value={row.ds_id}>{row.alias}</MenuItem>
                ))}
              </Select>
              <FormHelperText>Label + placeholder</FormHelperText>
            </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <FormControlLabel
                  value={fields.active}
                  control={<Checkbox id="active" size="medium" checked={fields.active} value={fields.active} onChange={handleFieldChange} color="primary" />}
                  label="Aktiv"
                  labelPlacement="end"
                />
                <FormHelperText>Aktiverer featuretype</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <FormControlLabel
                  value={fields.is_interesse}
                  control={<Checkbox id="is_interesse" size="medium" checked={fields.is_interesse} value={fields.is_interesse} onChange={handleFieldChange} color="primary" />}
                  label="Er interesseområde"
                  labelPlacement="end"
                />
                <FormHelperText>Markér som interesseområde. Denne featuretype vil blive brugt til at definere et interesseområde</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <FormControlLabel
                  value={fields.is_manuel}
                  control={<Checkbox id="is_manuel" size="medium" checked={fields.is_manuel} value={fields.is_manuel} onChange={handleFieldChange} color="primary" />}
                  label="Udtages til manuel behandling"
                  labelPlacement="end"
                />
                <FormHelperText>Markér som område for manuel behandling. Forespørgsler der rammer områder i denne kilde vil automatisk blive udtaget til manuel behandling</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item>
              {errorMessage.map(error => (
              <Typography variant="overline" display="block" color={"secondary"}>            
                {error}
              </Typography>
              ))}               
            </Grid>
            <Grid item style={{width: 450}}>
              <TextFieldFullWidth
                id="config"
                label="Config"
                placeholder="{}"
                helperText="Konfiguration til featuretype"
                value={fields.config}
                onChange={handleFieldChange}
                isLoading={isLoading}
                multiline
                minRows={8}
              />
            </Grid>
            <Grid item style={{width: 450}}>
              <TextFieldFullWidth
                id="transform"
                label="Transformation"
                placeholder="{}"
                helperText="Transformering til XML"
                value={fields.transform}
                onChange={handleFieldChange}
                isLoading={isLoading}
                multiline
                minRows={8}
              />
            </Grid>  
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            {props.cancelText}
          </Button>
          <Button 
          //onClick={action} 
          color="primary" variant="contained" autoFocus type="submit" disabled={!validateForm()}>
            {props.acceptText}
          </Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}